<template>
  <v-container fluid>
    <v-row>
      <fragment>
        <div @click="collapsed = !collapsed">
          <sideMenu
            :externalLinks="jsonData.externalLinks"
            :collapsed="collapsed"
            :leave="leave"
            :closeMenu="closeMenu"
            :handleCommand="handleCommand"
            :disableClick="!showPrompt"
          />
        </div>
        <v-col class="terminal">
          <v-row @click="stopWelcomeMessage = true">
            <welcomeMessage
              :stopMessage="stopWelcomeMessage"
              :message="jsonData.terminal.startingMessage"
              :onComplete="
                () => {
                  this.showPrompt = true;
                }
              "
            />
          </v-row>
          <v-row
            class="commandHistory"
            v-for="(command, index) in commands"
            :key="index"
            ref="messageDisplay"
          >
            <component :is="command.component" :command="command" />
          </v-row>
          <v-row v-if="showPrompt">
            <div class="prompt">{{ promptMessage }}</div>
            <input
              ref="terminalInput"
              v-on:blur="setAutoFocus"
              v-click-outside="setAutoFocus"
              class="terminalInput"
              type="text"
              v-on:keydown.13="handleCommand(null)"
              v-on:keydown.38="navigateCommands(-1)"
              v-on:keydown.40="navigateCommands(1)"
              v-model="newCommand"
              :disabled="disabledTerminal"
              autofocus
            />
          </v-row>
          <v-row>
            <span v-if="leave" class="prompt">{{ promptMessage }}</span>
            <span class="historyText" id="leaveMessage"></span>
          </v-row>
          <v-row class="blank_line"></v-row>
        </v-col>
      </fragment>
    </v-row>
  </v-container>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Typed from 'typed.js';
import * as handler from '../terminal';
import router from '../router';
import sideMenu from './menu';
import welcomeMessage from './welcomeMessage';
import { mapGetters } from 'vuex';
import singlePrint from './commands/singlePrint';
import openLink from './commands/openLink';
import commandPreview from './commands/commandPreview';
import experience from './commands/experience';
import skills from './commands/skills';

export default {
  name: 'terminal',
  components: {
    sideMenu,
    welcomeMessage,
    singlePrint,
    openLink,
    commandPreview,
    experience,
    skills
  },
  directives: {
    ClickOutside
  },
  computed: {
    ...mapGetters(['jsonData'])
  },
  data() {
    return {
      commands: [],
      eventSubscription: null,
      showPrompt: false,
      disabledTerminal: false,
      promptMessage: '',
      leave: false,
      newCommand: '',
      collapsed: true,
      stopWelcomeMessage: false
    };
  },
  methods: {
    closeMenu() {
      this.collapsed = true;
    },
    setAutoFocus() {
      if (this.$refs.terminalInput) this.$refs.terminalInput.focus();
    },
    navigateCommands(index) {
      this.newCommand = handler.navigateCommands(index);
    },
    handleCommand(incomingCommand = undefined) {
      if (incomingCommand) this.newCommand = incomingCommand;

      if (!this.disabledTerminal)
        handler.terminal(
          this.newCommand,
          this.jsonData,
          ({ info, component }) => {
            if (info === 'clear') {
              this.commands = [];
              this.newCommand = '';
              return;
            }
            if (info === 'Downloading CV ...') {
              this.disabledTerminal = true;
            }
            if (info === 'exit') {
              router.push('/');
              return;
            }
            this.newLine({ info, component });
          }
        );
    },
    newLine({ info, component = 'singlePrint' }) {
      const { prompt } = this.jsonData.terminal;

      this.commands.push({
        prompt: prompt,
        text: this.newCommand,
        component: 'singlePrint'
      });
      this.newCommand = '';
      this.commands.push({
        prompt: '',
        data: info,
        component: component
      });
      setTimeout(() => {
        this.scrollToBottom();
      }, 10);
    },
    scrollToBottom() {
      let elem = this.$el.getElementsByClassName('blank_line')[0];
      elem.scrollIntoView({
        block: 'start',
        inline: 'end'
      });
    }
  },
  created() {},
  watch: {
    jsonData: function() {
      this.promptMessage = this.jsonData.terminal.prompt;
    }
  },
  mounted() {
    this.promptMessage = this.jsonData.terminal.prompt;
    let event = handler.event.asObservable();

    this.eventSubscription = event.subscribe(message => {
      this.commands.splice(this.commands.length, 0, {
        prompt: '',
        text: message,
        error: false,
        component: 'singlePrint'
      });
      this.disabledTerminal = false;
    });
  },
  beforeDestroy() {
    this.eventSubscription.unsubscribe();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.leave && this.showPrompt) {
      this.disabledTerminal = true;
      this.leave = true;
      new Typed('#leaveMessage', {
        strings: [this.jsonData.commands.exit],
        typeSpeed: 40,
        showCursor: false,
        onComplete: () => {
          setTimeout(() => {
            next();
          }, 1500);
        }
      });
    } else next();
  }
};
</script>

<style>
.loader {
  color: #009b64ba;
  margin-top: 20vh;
  overflow: hidden;
}

.col {
  padding-left: 80px;
  overflow-x: hidden;
  padding-bottom: 0;
}

.historyText {
  white-space: pre-line;
  padding-left: 10px;
  position: relative;
  top: -1px;
  max-width: 90%;
  word-break: break-word;
}

.blank_line {
  min-height: 20px;
  margin-bottom: 20px;
}

.commandHistory {
  word-break: break-all;
}

.prompt {
  color: purple;
}

.terminalInput {
  color: white;
  width: 100%;
  flex: 1;
  outline: none;
  padding-left: 10px;
  position: relative;
  top: -1px;
}

.container {
  padding-top: 0;
  padding-bottom: 0;
}

.terminal {
  font-size: 2.7vh;
}

.container {
  padding-top: 0;
}

.terminal {
  font-size: 24px;
}

@media screen and (max-device-width: 600px) and(orientation: landscape) {
  .col-2 {
    flex: 0 0 11.333333% !important;
    max-width: 11.333333% !important;
  }
}

@media screen and (min-device-width: 1100px) {
  .col-lg-1 {
    flex: 0 0 5.333333%;
    max-width: 5.333333%;
  }
}

@media screen and (min-device-width: 1400px) {
  .col-lg-1 {
    flex: 0 0 3.333333%;
    max-width: 3.333333%;
  }
}
</style>
